import { Text, Box, chakra, useTheme, Flex } from '@chakra-ui/react';
import React from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

type FilterDatePickerProps = {
  startDate: Date | null;
  endDate: Date | null;
  setStartDate: React.Dispatch<React.SetStateAction<Date | null>>;
  setEndDate: React.Dispatch<React.SetStateAction<Date | null>>;
  label?: string;

  // Passthru props
  FlexProps?: React.ComponentProps<typeof Flex>;
};

/* ---- NOTES ----
We have <FilterDatePicker/> because we had trouble with <FullDateRangePicker/> in setting {startDate = date, endDate = null} 
Issue stems from a limitation in ReactDatePicker package. Next steps would be to use a different date picker package. */
export const FilterDatePicker = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  label = 'Date range',
  FlexProps,
}: FilterDatePickerProps) => {
  // use chakra factory to allow chakra to modify 3rd party component styles
  const theme = useTheme();
  const ChakraReactDatePicker = chakra(DatePicker, {
    baseStyle: { bg: theme.components.ChakraReactDatePicker.baseStyle.bg },
  });

  return (
    <Flex
      alignItems="center"
      gap="0.5rem"
      maxWidth="500px"
      sx={{
        '& .react-datepicker select': {
          background: 'transparent',
        },
      }}
      {...FlexProps}
    >
      <Text minWidth="90px">{label}</Text>
      <Box
        style={{
          borderWidth: '2px',
          borderRadius: '5px',
          padding: '7px',
        }}
      >
        <ChakraReactDatePicker
          selected={startDate}
          onChange={(date: Date) => setStartDate(date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          dateFormat="MMMM d, yyyy"
          placeholderText="Earliest"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          isClearable
        />
      </Box>
      <Text>to</Text>
      <Box
        style={{
          borderWidth: '2px',
          borderRadius: '5px',
          padding: '7px',
        }}
      >
        <ChakraReactDatePicker
          selected={endDate}
          onChange={(date: Date) => setEndDate(date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          dateFormat="MMMM d, yyyy"
          placeholderText="Latest"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          isClearable
        />
      </Box>
    </Flex>
  );
};
